// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creator__spotlights[data-v-6bfbf9a9]{display:flex;flex-direction:column}@media(min-width:992px){.creator__spotlights[data-v-6bfbf9a9]{flex-direction:row;justify-content:space-between}}.red-title[data-v-6bfbf9a9]{color:#f96862}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
